export default {
  header: 'Add Business Card',
  postalCodeLabel: 'Postal Code',
};
